export default __webpack_public_path__ + "static/equirectangular-basemap-02-min-d4f25cc5472a9e2142fc6b56422df76e.png";